import { render } from "./DiscussionQuestItem.vue?vue&type=template&id=78572d01&scoped=true"
import script from "./DiscussionQuestItem.vue?vue&type=script&charset=utf-8&lang=js"
export * from "./DiscussionQuestItem.vue?vue&type=script&charset=utf-8&lang=js"

import "./DiscussionQuestItem.vue?vue&type=style&index=0&id=78572d01&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78572d01"]])

export default __exports__